<template>
<div class="slide slide05">
    <h3 class="title">
        <div class="mo">가상화폐 거래소 캠페인</div>
        Strategy &amp; Result
    </h3>
    <span class="text">
        신규 회원가입 및 거래량 증대를 목표로 캠페인 최적화와 반응률 높은 크리에이티브 운영하여 <br>
        가상화폐 온라인 시장을 선점하고 주도하며 공격적인 마케팅으로 양적&amp;질적 두가지 목표 달성, 업계 압도적 1위 유지
    </span>
    <div class="graphWrap">
        <div class="graph g1">
            <ul class="list">
                <li class="no1">
                    <div class="txt t1">
                        운영 초기<br>
                        비트코인 상승<br>
                        가능성 소구
                    </div>
                    <div class="txt t2">잠재고객 확보</div>
                </li>
                <li class="no2">
                    <div class="txt t1">
                        가격 상승 후<br>
                        소액으로 구매<br>
                        가능성 소구
                    </div>
                    <div class="txt t2">신규고객 확보</div>
                </li>
            </ul>
        </div>
        <div class="graph g2">
            <img src="@/assets/images/graphImg07.png" alt="가상화폐 거래소 CPA 개선 추이">
            <div class="txt">
                이관 직후 매우 저조한 전환 및 높은 CPA를 보였으나, <br>
                캠페인 최적화 세팅 및 반응률 높은 크리에이티브 운영으로 <br>
                약 6개월만에 전환수 10배 상승 및 CPA 안정화 달성
            </div>
        </div>
    </div>

    <div class="btnsWrap">
		<a herf="javascript:;" @click="fnSlickNext" class="slideNextBtn" v-if="!$device.windows">다음 페이지</a>
	</div>
</div>
</template>
<script>
export default {
    methods:{
		fnPopClose(){
			this.$emit('popClose' , event)
		},
		fnSlickNext(){
			this.$emit('slick_next' , event)
		}
	}
}
</script>